import React, { useEffect, useState } from "react";
import { authApi } from "../api";

const LowStockPanel = ({ onCountChange }) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [rows, setRows] = useState([]);

  const load = async () => {
    setLoading(true);
    setError("");
    try {
      const res = await authApi.get("/inventory/low-stock");
      const data = res.data?.materials || [];
      setRows(data);
      if (onCountChange) onCountChange(data.length);
    } catch (e) {
      setError(e?.response?.data?.error || "Failed to load low stock panel");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="h-full overflow-y-auto bg-slate-50 p-4 md:p-6">
      <div className="flex items-center justify-between">
        <h1 className="text-xl md:text-2xl font-bold text-slate-800">Low Stock</h1>
        <button onClick={load} className="px-3 py-2 rounded bg-blue-600 text-white text-sm hover:bg-blue-700">Refresh</button>
      </div>
      {error && <div className="mt-3 rounded-lg border border-red-200 bg-red-50 text-red-700 px-4 py-3 text-sm">{error}</div>}
      {loading ? (
        <div className="mt-4 space-y-2">
          {Array.from({ length: 8 }).map((_, i) => <div key={i} className="h-12 bg-slate-200 rounded animate-pulse" />)}
        </div>
      ) : (
        <div className="mt-4 bg-white border border-slate-200 rounded-xl shadow-sm overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-slate-50 text-slate-500 uppercase text-xs">
              <tr>
                <th className="px-4 py-3 text-left">Material</th>
                <th className="px-4 py-3 text-right">Current</th>
                <th className="px-4 py-3 text-right">Reorder Level</th>
                <th className="px-4 py-3 text-right">Shortage</th>
                <th className="px-4 py-3 text-left">Last Batch</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {rows.map((r) => (
                <tr key={r.material_id}>
                  <td className="px-4 py-3">
                    <div className="font-medium">{r.name}</div>
                    <div className="text-xs text-slate-400">{r.code}</div>
                  </td>
                  <td className="px-4 py-3 text-right">{Number(r.current_stock || 0).toFixed(3)} {r.uom}</td>
                  <td className="px-4 py-3 text-right">{Number(r.reorder_level || 0).toFixed(3)}</td>
                  <td className="px-4 py-3 text-right text-red-600">{Number(r.shortage || 0).toFixed(3)}</td>
                  <td className="px-4 py-3">{r.last_batch_date ? new Date(r.last_batch_date).toLocaleDateString() : "N/A"}</td>
                </tr>
              ))}
              {!rows.length && <tr><td colSpan="5" className="px-4 py-8 text-center text-slate-400">No low stock materials.</td></tr>}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default LowStockPanel;
